module.exports = __webpack_public_path__ + "static/media/liqualityLogo.f08de919.svg";